import { useEffect, useRef } from "react";
import { notify } from "@dehub/theme";
import type { MessagePayload } from "firebase/messaging";
import { onMessageListener, requestForToken } from "./fcm-service";

export function useFirebaseNotifications(accessToken: string | null | undefined) {
  const tokenRequested = useRef(false);

  useEffect(() => {
    if (!accessToken || tokenRequested.current) return;
    tokenRequested.current = true;
    requestForToken();
  }, [accessToken]);

  useEffect(() => {
    if (!accessToken) return;
    let unsub: (() => void) | undefined;
    onMessageListener((payload: MessagePayload, off: () => void) => {
      unsub = off;
      notify.info({
        id: `notif-${Date.now()}`,
        title: payload?.notification?.title ?? "New Notification",
        message: payload?.notification?.body ?? "You have a new message.",
        autoClose: 6000,
      });
    });
    return () => unsub?.();
  }, [accessToken]);
}
